/* ============================================================
   CURATOR PRODUCT CARD - interactions
   ------------------------------------------------------------
   Wishlist, add to tote and quick view for the `curator-card-product`
   snippet.

   This logic used to live inside curator-collection-grid.liquid, which meant
   the card only worked inside that one section. Anywhere else the buttons
   rendered but did nothing, so the homepage In Focus row used Dawn's plain
   card instead and had no wishlist or tote button at all.

   Uses event delegation on the document rather than binding each button, so
   cards injected later (infinite scroll, section re-render, quick view) work
   with no re-initialisation.

   window.CuratorWishlist is resolved at click time, never at load time: this
   file can run before the wishlist snippet near the end of theme.liquid has
   defined it.
   ============================================================ */
(function () {
  'use strict';

  /* Several sections include this file (two product rows on the home page, the product page
     plus its rail row). Without this guard every copy attached its own document click handler,
     so one tap on a heart saved and then removed the product, and one tap on the tote icon
     added the product twice. Set up once per page. */
  if (window.__mmCuratorCardInit) return;
  window.__mmCuratorCardInit = true;

  /* ---- Cart icon refresh ----
     Adding the FIRST item used to leave the count bubble missing until the
     next page load. The bubble is rendered server side inside
     `{%- if cart != empty -%}`, so on an empty cart there is no
     .cart-count-bubble in the DOM at all, and the old code only wrote
     textContent into whatever it could find. With nothing to find, nothing
     happened, and the count appeared only once the server rendered the header
     again.

     Re-rendering sections/cart-icon-bubble.liquid through the Section
     Rendering API covers every case at once: creating the bubble on the first
     add, updating the number after that, removing it if the cart empties, and
     swapping the empty cart icon for the filled one.

     The icon and the bubble are swapped individually rather than replacing the
     whole link, because the header words the link's accessible label "Open
     tote" while the section says "Cart", and replacing wholesale would quietly
     change it for screen readers. */
  window.MMRefreshCartIcon = function () {
    return fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-icon-bubble'];
        var host = document.getElementById('cart-icon-bubble');
        if (!html || !host) return;

        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var newIcon = tmp.querySelector('.svg-wrapper');
        var oldIcon = host.querySelector('.svg-wrapper');
        if (newIcon && oldIcon) oldIcon.replaceWith(newIcon);

        var newBubble = tmp.querySelector('.cart-count-bubble');
        var oldBubble = host.querySelector('.cart-count-bubble');
        if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);
        else if (newBubble) host.appendChild(newBubble);
        else if (oldBubble) oldBubble.remove();
      })
      .catch(function () {});
  };

  /* ---- Cart drawer ----
     Call after a successful add to cart. Dawn opens its drawer from
     product-form.js, which none of this theme's add to cart paths go through:
     the card button, the quick view and the product page all post to
     /cart/add.js themselves. With the drawer switched on but nothing calling
     it, adding an item would have updated the badge and nothing else.

     Rather than rewrite all five of those posts to ask for sections in the
     add request the way Dawn does, the sections are fetched here afterwards
     and handed to the drawer's own renderContents. That re-renders the drawer
     AND the cart icon and then opens it, so this one call replaces the badge
     refresh at every site.

     Falls back to refreshing just the icon when no drawer is present, so
     switching the cart type back to notification or page still works. */
  window.MMOpenCartDrawer = function (openedBy) {
    var host = document.querySelector('cart-drawer');
    if (!host || typeof host.renderContents !== 'function') {
      return window.MMRefreshCartIcon();
    }
    var ids = (typeof host.getSectionsToRender === 'function'
      ? host.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble']).join(',');

    return Promise.all([
      fetch('/?sections=' + encodeURIComponent(ids)).then(function (r) { return r.json(); }),
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    ])
      .then(function (res) {
        var sections = res[0];
        var cart = res[1];

        /* Clear is-empty on the host before rendering.

           Liquid puts the class on the <cart-drawer> element itself:
             <cart-drawer class="drawer{% if cart == empty %} is-empty{% endif %}">
           but renderContents only replaces the innerHTML of the #CartDrawer div
           inside it, and only ever clears is-empty from .drawer__inner. So on a
           cart that was empty when the page loaded, the class survived the
           re-render, and component-cart.css has

             .is-empty .cart__contents { display: none }

           which hid the entire item list. The footer uses .drawer__footer, not
           .cart__footer, so it stayed visible: the drawer opened showing the
           right total over a blank space where the products should be. */
        host.classList.toggle('is-empty', cart.item_count === 0);

        if (openedBy && typeof host.setActiveElement === 'function') {
          host.setActiveElement(openedBy);
        }
        host.renderContents({ sections: sections });
      })
      .catch(function () { return window.MMRefreshCartIcon(); });
  };

  function wishlistReady() {
    return typeof window.CuratorWishlist !== 'undefined' && window.CuratorWishlist;
  }

  /* ---- Wishlist ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.curator-card__wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    if (!wishlistReady()) return;

    var added = window.CuratorWishlist.toggle({
      id: btn.getAttribute('data-product-id'),
      variant_id: btn.getAttribute('data-variant-id'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      url: btn.getAttribute('data-product-url'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      compare_at_price: btn.getAttribute('data-product-compare-price')
    });
    btn.classList.toggle('is-wishlisted', !!added);
  });

  /* ---- Size picker ----
     A product with variants is never added blind: picking a size on the shopper's behalf is how you
     end up shipping the wrong one. The sheet lists each option, crosses out what is sold out and
     adds the chosen variant to the tote. */
  function money(paise) {
    var n = Math.round(paise) / 100;
    return '\u20B9' + n.toLocaleString('en-IN', { maximumFractionDigits: n % 1 ? 2 : 0 });
  }
  function closePicker() {
    var open = document.querySelector('.mm-pick');
    if (!open) return;
    var back = open.__opener;
    open.remove();
    document.documentElement.classList.remove('mm-pick-open');
    if (back && back.focus) back.focus({ preventScroll: true });
  }
  function openPicker(handle, url, opener) {
    closePicker();
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .then(function (product) {
        var chosen = product.options.map(function () { return null; });
        var root = document.createElement('div');
        root.className = 'mm-pick';
        root.__opener = opener;
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-modal', 'true');
        root.setAttribute('aria-label', 'Choose ' + product.options.map(function (o) { return o.name.toLowerCase(); }).join(' and '));
        var html = '<div class="mm-pick__backdrop" data-pick-close></div><div class="mm-pick__panel">' +
          '<button type="button" class="mm-pick__close" data-pick-close aria-label="Close">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
          '<div class="mm-pick__head">' + (product.featured_image ? '<img src="' + product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="64" height="80" loading="lazy">' : '') +
          '<div><p class="mm-pick__title"></p><p class="mm-pick__price" data-pick-price></p></div></div>';
        product.options.forEach(function (opt, i) {
          html += '<fieldset class="mm-pick__group" data-pick-group="' + i + '"><legend></legend><div class="mm-pick__values"></div></fieldset>';
        });
        html += '<p class="mm-pick__msg" data-pick-msg role="status"></p>' +
          '<button type="button" class="mm-pick__add" data-pick-add disabled></button>' +
          '<a class="mm-pick__more" href="' + (url || '/products/' + handle) + '">See full details</a></div>';
        root.innerHTML = html;
        root.querySelector('.mm-pick__title').textContent = product.title;
        var priceEl = root.querySelector('[data-pick-price]');
        var addBtn = root.querySelector('[data-pick-add]');
        var msg = root.querySelector('[data-pick-msg]');

        function variantFor() {
          for (var v = 0; v < product.variants.length; v++) {
            var ok = true;
            for (var i = 0; i < chosen.length; i++) if (product.variants[v].options[i] !== chosen[i]) ok = false;
            if (ok) return product.variants[v];
          }
          return null;
        }
        function availableWith(i, value) {
          return product.variants.some(function (v) {
            if (!v.available || v.options[i] !== value) return false;
            for (var k = 0; k < chosen.length; k++) if (k !== i && chosen[k] !== null && v.options[k] !== chosen[k]) return false;
            return true;
          });
        }
        function draw() {
          product.options.forEach(function (opt, i) {
            var group = root.querySelector('[data-pick-group="' + i + '"]');
            group.querySelector('legend').textContent = opt.name + (chosen[i] ? ': ' + chosen[i] : '');
            var box = group.querySelector('.mm-pick__values');
            box.innerHTML = '';
            opt.values.forEach(function (value) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'mm-pick__value' + (chosen[i] === value ? ' is-chosen' : '');
              b.textContent = value;
              b.setAttribute('aria-pressed', chosen[i] === value ? 'true' : 'false');
              if (!availableWith(i, value)) { b.disabled = true; b.classList.add('is-out'); b.setAttribute('aria-label', value + ', sold out'); }
              b.addEventListener('click', function () { chosen[i] = value; msg.textContent = ''; draw(); });
              box.appendChild(b);
            });
          });
          var complete = chosen.every(function (c) { return c !== null; });
          var variant = complete ? variantFor() : null;
          priceEl.textContent = money(variant ? variant.price : product.price);
          addBtn.disabled = !(variant && variant.available);
          addBtn.textContent = !complete ? 'Choose ' + product.options.map(function (o) { return o.name.toLowerCase(); }).join(' and ') : (variant && variant.available ? 'Add to tote' : 'Sold out');
          addBtn.classList.toggle('is-ready', !!(variant && variant.available));
          addBtn.__variant = variant;
        }
        addBtn.addEventListener('click', function () {
          var variant = addBtn.__variant;
          if (!variant) return;
          addBtn.disabled = true; addBtn.classList.remove('is-ready'); addBtn.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
          })
            .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'add'); return d; }); })
            .then(function () { closePicker(); return window.MMOpenCartDrawer(opener); })
            .catch(function (err) {
              msg.textContent = (err && err.message && err.message !== 'add') ? err.message : 'Could not add this piece. Please try again.';
              draw();
            });
        });
        root.addEventListener('click', function (ev) { if (ev.target.closest('[data-pick-close]')) closePicker(); });
        root.addEventListener('keydown', function (ev) {
          if (ev.key === 'Escape') { closePicker(); return; }
          if (ev.key !== 'Tab') return;
          var f = root.querySelectorAll('button:not([disabled]), a[href]');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
          else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
        });
        document.body.appendChild(root);
        document.documentElement.classList.add('mm-pick-open');
        draw();
        var firstValue = root.querySelector('.mm-pick__value:not([disabled])') || root.querySelector('.mm-pick__close');
        if (firstValue) firstValue.focus({ preventScroll: true });
      })
      .catch(function () { if (url) window.location.href = url; });
  }

  /* ---- Add to tote ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.curator-card__cart-btn');
    if (!btn) return;
    e.preventDefault();

    if (btn.getAttribute('data-has-variants') === 'true') {
      /* Needs a size or colour chosen first: ask for it in a small sheet, right where the shopper is
         (owner, 28 Sep 2026). The product page is only the fallback when the sheet cannot load. */
      var card = btn.closest('.curator-card');
      var handle = btn.getAttribute('data-product-handle') ||
                   (card && card.getAttribute('data-product-handle'));
      var url = (card && card.getAttribute('data-product-url')) || btn.getAttribute('data-product-url');
      if (handle) { openPicker(handle, url, btn); return; }
      if (url) window.location.href = url;
      return;
    }

    var vid = btn.getAttribute('data-variant-id');
    if (btn.getAttribute('data-available') !== 'true' || !vid) return;

    btn.style.opacity = '1';
    btn.style.color = '#27ae60';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        setTimeout(function () { btn.style.color = ''; btn.style.opacity = ''; }, 1200);
        return window.MMOpenCartDrawer(btn);
      })
      .catch(function () { btn.style.color = ''; btn.style.opacity = ''; });
  });

  /* ---- Buy now ----
     A piece without sizes is added and the shopper goes straight to checkout (anything already in the tote
     comes too, as it would from the tote). A piece with sizes opens its page, where the size is chosen. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.curator-card__buy-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var url = btn.getAttribute('data-product-url');
    if (btn.getAttribute('data-has-variants') === 'true' || btn.getAttribute('data-available') !== 'true') {
      if (url) window.location.href = url;
      return;
    }
    if (btn.getAttribute('aria-busy') === 'true') return;
    var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!vid) { if (url) window.location.href = url; return; }
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/checkout'; })
      .catch(function () { btn.removeAttribute('aria-busy'); if (url) window.location.href = url; });
  });

  /* ---- Quick view ----
     The modal lives in curator-collection-grid.liquid, which publishes
     window.CuratorQuickView. Elsewhere there is no modal, so fall back to
     opening the product page. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.curator-card__quick-view-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-product-handle');
    if (handle && typeof window.CuratorQuickView === 'function') {
      window.CuratorQuickView(handle);
      return;
    }
    var url = btn.getAttribute('data-product-url');
    if (url) window.location.href = url;
  });

  /* Reflect saved state on cards as they appear. */
  function syncHearts(root) {
    if (!wishlistReady()) return;
    (root || document).querySelectorAll('.curator-card__wishlist-btn').forEach(function (btn) {
      var h = btn.getAttribute('data-product-handle');
      if (h) btn.classList.toggle('is-wishlisted', window.CuratorWishlist.isInWishlist(h));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncHearts(); });
  } else {
    syncHearts();
  }

  document.addEventListener('wishlist:changed', function () { syncHearts(); });

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && n.querySelector && n.querySelector('.curator-card__wishlist-btn')) {
            syncHearts(n);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
